import moment from 'moment';
import React, { useState } from 'react'
import { formatDate } from '../helpers/frontend';
import { useSelector } from 'react-redux';
import { ImagePath } from '../config/apiEndPoints';

function CompanyDetails({ handleData }) {
    const d = handleData?.data
    const countries = useSelector((state) => state.data?.countries)
    const plansData = useSelector((state) => state.commenData.allPlans)
    const validSelection = Array.isArray(d?.service_type)
        ? d?.service_type
        : JSON.parse(d?.service_type || "[]");
    const findPlan = plansData?.data?.find((item) => {
        return item?.id == d?.plan_id
    })
    // //console.log("handleData", d);

    return (
        <div
            style={handleData?.isOpen ? { display: "block",background:"rgba(0,0,0,0.24)" } : {}}
            class={`modal fade ${handleData?.isOpen ? "show" : ""} `}
            id="edit_company" >
            <div class="modal-dialog modal-dialog-centered modal-lg  ">
                <div class="modal-content shadow">
                    <div class="modal-header">
                        <h4 class="modal-title">Company Details</h4>
                        <button type="button"
                            class="btn-close custom-btn-close"
                            onClick={handleData.onClose}
                        >
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                    <div className='p-4'>
                        <div className="company-info p-3 mb-3 flex gap-2 align-items-center rounded">
                            <span className='avatar  '>
                                <img className='img-fluid rounded-circle' src={d.company_logo ? ImagePath + d.company_logo : "/assets/img/company/company-02.svg"} alt='profile' />
                            </span>
                            <div>
                                <h5 className="mb-1">{d.company_name || "NA"}</h5>
                                <p className="text-muted mb-1">{d.company_email || d?.admin_email || "NA"}</p>
                                <span className={`status-badge fs-14 ${d.status == "Hold" ? "badge badge-warning " : d.status == "Active" ? "" : "badge badge-danger"} `}>● {d.status || "NA"}</span>
                            </div>
                        </div>

                        <h6 className="section-title">Basic Info</h6>
                        <div className="row mb-3">
                            <div className="col-md-4 pb-2">
                                <strong>Company Name</strong>
                                <p>{d.company_name || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Company Id</strong>
                                <p>{d.company_id || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Company Size</strong>
                                <p>{d.team_size || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Phone Number</strong>
                                <p>{d.contact_no || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Domain Name</strong>
                                <p>{d.company_domain || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Admin Email</strong>
                                <p>{d.admin_email || "NA"}</p>
                            </div>

                            <div className="row py-2">
                                <h6 className="section-title">Address</h6>
                                <div className="col-md-4">
                                    <strong>Address</strong>
                                    <p>{d.company_address || "NA"}</p>
                                </div>
                                <div className="col-md-2">
                                    <strong>City</strong>
                                    <p>{d.city || "NA"}</p>
                                </div>
                                <div className="col-md-2">
                                    <strong>State</strong>
                                    <p>{d.state || "NA"}</p>
                                </div>
                                <div className="col-md-2">
                                    <strong>Country</strong>
                                    <p>{countries.find((c) => { return c.id == d.country })?.name || "NA"}</p>
                                </div>
                                <div className="col-md-2">
                                    <strong>Pin Code</strong>
                                    <p>{d.pincode || "NA"}</p>
                                </div>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Status</strong>
                                <p>{d.status || "NA"}</p>
                            </div>
                        </div>

                        <h6 className="section-title">Plan Details</h6>
                        <div className="row">
                            <div className="col-md-4 pb-2">
                                <strong>Plan Name</strong>
                                <p>{findPlan?.name || "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Plan Type</strong>
                                <p>{findPlan?.duration || "NA"} ({findPlan?.price})</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Plan Start Date</strong>
                                <p>{d?.current_plan?.start_date ? formatDate(d?.current_plan?.start_date) : "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Plan End Date</strong>
                                <p>{d?.current_plan?.end_date ? formatDate(d?.current_plan?.end_date) : "NA"}</p>
                            </div>
                            <div className="col-md-4 pb-2">
                                <strong>Service Type</strong>
                                <p className='text-capitalize '>
                                    {
                                        d?.current_plan?.services?.map((item, i) => {
                                            return item?.name
                                        }).join()
                                    }
                                </p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompanyDetails
